import packageInfo from '../../../../package.json';

export const APP_VERSION: string = packageInfo.version;

export function getAppVersion(): string {
    const nativeVersion = (window as Window & { appVersion?: string | null }).appVersion;
    if (typeof nativeVersion === 'string' && nativeVersion.trim()) {
        return nativeVersion.trim();
    }
    return APP_VERSION;
}
